// @flow

import React from "react";
import Tabs from "components/Tabs";
import People from "@material-ui/icons/People";
import TableTshirt from "./TableTshirt";
import * as resources from "resources";
import TableTshirtStaff from "./TableTshirtStaff";

const SiteTshirtTabs = (props) => {
  /* author: Ian Laird
   *
   * all of the tabs display the same information except for Staff which is why all but staff use the same component
   * just with different urls passed to it
   *
   * All but staff display
   *      Name: the name of the person
   *      Shirt Size
   *      Institution: the name of that person's institution unit
   *      Team: the name of the team that person belongs to in the site
   *
   * Staff Displays:
   *   name: the name of the staff member
   *   size: the shirt size
   *   role: the badge role of the staff member
   *
   * Note: the url are generated on a site by site basis by methods present in "resources"
   *
   * TODO implement export and filtering
   */
  const tabs = [
    {
      icon: <People />,
      label: "Coaches",
      content: (
        <div style={{ padding: 0 }}>
          <TableTshirt
            tshirtURL={resources.TableResources.SITE_TSHIRT_COACH(props.siteId)}
            exportURL={resources.Export.SITE_TSHIRT_COACH_EXPORT(props.siteId)}
          />
        </div>
      ),
      data_test: "coaches_tab",
    },
    {
      icon: <People />,
      label: "Co-coaches",
      content: (
        <div style={{ padding: 0 }}>
          <TableTshirt
            tshirtURL={resources.TableResources.SITE_TSHIRT_COCOACH(
              props.siteId
            )}
            exportURL={resources.Export.SITE_TSHIRT_COCOACH_EXPORT(
              props.siteId
            )}
          />
        </div>
      ),
      data_test: "co_coaches_tab",
    },
    {
      icon: <People />,
      label: "Contestants",
      content: (
        <div style={{ padding: 0 }}>
          <TableTshirt
            tshirtURL={resources.TableResources.SITE_TSHIRT_CONTESTANT(
              props.siteId
            )}
            exportURL={resources.Export.SITE_TSHIRT_CONTESTANT_EXPORT(
              props.siteId
            )}
          />
        </div>
      ),
      data_test: "contestants_tab",
    },
    {
      icon: <People />,
      label: "Attendees",
      content: (
        <div style={{ padding: 0 }}>
          <TableTshirt
            tshirtURL={resources.TableResources.SITE_TSHIRT_ATTENDEE(
              props.siteId
            )}
            exportURL={resources.Export.SITE_TSHIRT_ATTENDEE_EXPORT(
              props.siteId
            )}
          />
        </div>
      ),
      data_test: "attendees_tab",
    },
    {
      icon: <People />,
      label: "Reserves",
      content: (
        <div style={{ padding: 0 }}>
          <TableTshirt
            tshirtURL={resources.TableResources.SITE_TSHIRT_RESERVE(
              props.siteId
            )}
            exportURL={resources.Export.SITE_TSHIRT_RESERVE_EXPORT(
              props.siteId
            )}
          />
        </div>
      ),
      data_test: "reserves_tab",
    },
    {
      icon: <People />,
      label: "Staff",
      content: (
        <div style={{ padding: 0 }}>
          <TableTshirtStaff
            tshirtURL={resources.TableResources.SITE_TSHIRT_STAFF(props.siteId)}
            exportURL={resources.Export.SITE_TSHIRT_STAFF_EXPORT(props.siteId)}
          />
        </div>
      ),
      data_test: "staff_tab",
    },
  ];
  return <Tabs tabs={tabs} />;
};

export default SiteTshirtTabs;
